const MAX_VERSION_LENGTH = 3;

const allowedOperators = [
  '>',
  '>=',
  '=',
  '<',
  '<='
];

const operatorResMap = {
  '>': [1],
  '>=': [0, 1],
  '=': [0],
  '<=': [-1, 0],
  '<': [-1]
};

const validateOperator = (op) => {
  if (typeof op !== 'string') {
    throw new TypeError('Invalid operator type, expected string but got ' + typeof op);
  }
  if (allowedOperators.indexOf(op) === -1) {
    throw new TypeError('Invalid operator, expected one of ' + allowedOperators.join('|'));
  }
};

const compare = (version1, version2) => {
  const version1Array = version1.split('.');
  const version2Array = version2.split('.');
  const version1Length = version1Array.length;
  const version2Length = version2Array.length;

  if (version1Length > MAX_VERSION_LENGTH || version2Length > MAX_VERSION_LENGTH) {
    throw new Error('Invalid version');
  }

  version1Array.splice(version1Length, 0, ...(Array(MAX_VERSION_LENGTH - version1Length).fill(0)));
  version2Array.splice(version2Length, 0, ...(Array(MAX_VERSION_LENGTH - version2Length).fill(0)));

  for (let i = 0; i < MAX_VERSION_LENGTH; i++) {
    const v1 = parseInt(version1Array[i] || 0, 10);
    const v2 = parseInt(version2Array[i] || 0, 10);

    if (v1 > v2) {
      return 1;
    }

    if (v1 < v2) {
      return -1;
    }
  }

  return 0;
};

export default function compareVersions(version1, operator, version2) {
  validateOperator(operator);

  const result = compare(version1 ?? '', version2 ?? '');

  return operatorResMap[operator].indexOf(result) > -1;
};
